import get from 'lodash/get';

// abandoned cart notification prefix
export const ABANDONED_CART_NOTIFICATION = 'carts.recovery';

/**
 * Get series number from abandoned notification id: carts.recovery-5 => 5
 * @param {string} id - notification id
 * @returns {number} - series number
 */
export function getAbandonedCartNotificationSeries(id) {
  return id === ABANDONED_CART_NOTIFICATION
    ? 0
    : Number(id.replace(`${ABANDONED_CART_NOTIFICATION}-`, ''));
}

/**
 * Combine abandoned notification id
 * @param {number} series - series number
 * @returns {string} - notification id
 */
export function combineAbandonedCartNotificationId(series) {
  return `${ABANDONED_CART_NOTIFICATION}-${series}`;
}

/**
 * Prepare abandoned notification id
 * @param {number} series - series number
 * @returns {string} - notification id
 */
export function prepareAbandonedCartNotificationId(series) {
  return series <= 0
    ? ABANDONED_CART_NOTIFICATION
    : combineAbandonedCartNotificationId(series);
}

/**
 * Get current values
 * @param {object} values - all values
 * @returns {array} - filled abandoned cart notifications, skip incompleted values like {}
 */
export function getAbandonedCartNotifications(values) {
  return [...get(values.abandoned_cart, 'series', [])].filter(
    (value) => value?.delay > 0,
  );
}
